import script from "./WorkspaceLnb.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceLnb.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceLnb.vue?vue&type=style&index=0&id=2de5861c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de5861c"]])

export default __exports__